module.exports = __webpack_public_path__ + "img/filtro.6465ee15.svg";